import { Map } from 'immutable';

import { ADD, ADD_MULTIPLE, UPDATE, REMOVE } from './constants';

const initialState = Map();

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD:
      return state.set(action.picture.id, action.picture);

    case ADD_MULTIPLE:
      return state.merge(action.pictures);

    case UPDATE:
      return state.set(action.picture.id, action.picture);

    case REMOVE:
      return state.delete(action.payload.id);

    default:
      return state;
  }
};
